import { LIST_BOOKING } from '../constants'

const initState = {
	request: null,
	response: null,
	error: null,
}

export default function (state = initState, action) {
	switch (action.type) {
		case LIST_BOOKING.LOAD:
			return {
				...state,
				request: action.payload,
				response: null,
				error: null,
			}
		case LIST_BOOKING.SUCCESS:
			return {
				...state,
				response: action.response,
			}
		case LIST_BOOKING.ERROR:
			return {
				...state,
				error: action.error,
			}
		case LIST_BOOKING.CLEAR:
			return {
				...state,
				response: action.response,
			}
		default:
			return state
	}
}
